export const SUPPORT_EMAIL = "support@utahswimacademy.com";

export const SUPPORT_PHONE_NUMBER = "+1 (801) 367-0648";

export const OFFICE_HOURS = [
    {
        day: "Monday",
        hours: "8AM - 7PM"
    },
    {
        day: "Tuesday",
        hours: "8AM - 7PM"
    },
    {
        day: "Wednesday",
        hours: "8AM - 7PM"
    },
    {
        day: "Thursday",
        hours: "8AM - 7PM"
    },
    {
        day: "Friday",
        hours: "8AM - 7PM"
    },
    {
        day: "Saturday",
        hours: "9AM - 12PM"
    },
    {
        day: "Sunday",
        hours: "Closed"
    },
    {
        day: "Holidays",
        hours: "Varies"
    },
    {
        day: "9th & 10th of each month for schedule releases",
        hours: "7AM - 9PM"
    }
];

export const POOL_HOURS = [
    {
        day: "Monday",
        hours: "8AM - 8PM"
    },
    {
        day: "Tuesday",
        hours: "8AM - 8PM"
    },
    {
        day: "Wednesday",
        hours: "8AM - 8PM"
    },
    {
        day: "Thursday",
        hours: "8AM - 8PM"
    },
    {
        day: "Friday",
        hours: "8AM - 8PM"
    },
    {
        day: "Saturday",
        hours: "8AM - 2PM"
    },
    {
        day: "Sunday",
        hours: "Closed"
    },
    {
        day: "Holidays",
        hours: "Varies"
    }
];